import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  spaceBetween: {
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  rowCentered: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
  },

  pendingBadge: {
    backgroundColor: colors.backgroundPositive,
    borderRadius: theme.borderRadius.xxs,
    paddingHorizontal: theme.spacing[3],
    paddingVertical: theme.spacing[1],
    flexShrink: 0,
  },
  pendingBadgeText: {
    fontSize: 9,
    fontWeight: '700',
    color: colors.textStatic,
    textTransform: 'uppercase',
  },
  canceledBadge: {
    backgroundColor: colors.backgroundNegative,
    borderRadius: theme.borderRadius.xxs,
    paddingHorizontal: theme.spacing[3],
    paddingVertical: theme.spacing[1],
    flexShrink: 0,
  },
  canceledBadgeText: {
    fontSize: 9,
    fontWeight: '700',
    color: colors.textStatic,
    textTransform: 'uppercase',
  },
  paidBadge: {
    backgroundColor: colors.backgroundPositive,
    borderRadius: theme.borderRadius.xxs,
    paddingHorizontal: theme.spacing[3],
    paddingVertical: theme.spacing[1],
    flexShrink: 0,
  },
  paidBadgeText: {
    fontSize: 9,
    fontWeight: '700',
    color: colors.textStatic,
    textTransform: 'uppercase',
  },
}));
